export type { ToggleProps } from "@components/contracts/Toggle.types";
export { RsuiteToggle } from "./Toggle.adapter";
